import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>

  :host {
    display: inline-block;
  }

  /* by default, use font-family defined by theme */
  :host([font="icon"]) com-html {
    @apply --icon-font;
  }

  :host([font="pepmdx"]) com-html {
    font-family: "pepmdx";
  }

  :host([theme="hyp"]) {
    background-color: var(--com-icon-background-color);
    border-radius: 1em;
    padding: 0.2em 0.5em 0.1em;
  }

  :host([theme="hyp"]) com-html {
    color: var(--com-icon-color);
  }

  :host([theme="hyp"][color="alert"]) {
    --com-icon-background-color: #F8D9FF;
    --com-icon-color: #5E1977;
  }

  com-html {
    font: inherit;
    color: inherit;
  }

</style>
</template>`;

styleElement.register('com-icon-style');